// extracted by mini-css-extract-plugin
export var container = "_hi-0";
export var icon = "_hi-1";
export var text = "_hi-2";